import React from 'react';
import { initials } from '@/lib/format';
import styles from './Avatar.module.css';

const PASTELS = ['mint', 'butter', 'sky', 'blush'];

function getPastelVariant(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const idx = Math.abs(hash) % PASTELS.length;
  return PASTELS[idx];
}

export function Avatar({
  name = '',
  size = 'md',
  variant, // 'mint' | 'butter' | 'blush' | 'sky' | 'accent'
  className = ''
}) {
  const init = initials(name);
  const colorVariant = variant || getPastelVariant(name);

  return (
    <div
      className={`${styles.avatar} ${styles[size]} ${styles[colorVariant]} ${className}`}
      aria-hidden="true"
    >
      <span className={styles.initials}>{init}</span>
    </div>
  );
}

export function Person({
  name = '',
  meta,
  submeta,
  size = 'md',
  variant,
  className = '',
  onClick
}) {
  const isClickable = !!onClick;

  return (
    <div
      className={`${styles.person} ${isClickable ? styles.clickable : ''} ${className}`}
      onClick={onClick}
    >
      <Avatar name={name} size={size} variant={variant} />
      <div className={styles.personInfo}>
        <span className={styles.personName}>{name}</span>
        {meta && <span className={styles.personMeta}>{meta}</span>}
        {submeta && <span className={styles.personSubmeta}>{submeta}</span>}
      </div>
    </div>
  );
}
